import axios from 'axios'
import { getLocalstorageItem } from 'utils/localStorage'
import { LOCALSTORAGE_KEYS } from 'utils/constants'

axios.defaults.baseURL = ''

axios.interceptors.request.use(
   config => {
      const tokenApp = getLocalstorageItem(LOCALSTORAGE_KEYS.TOKEN_APP)
      if (tokenApp) {
         config.headers.Authorization = `Bearer ${tokenApp}`
         return config
      }
      return config
   },
   error => {
      return Promise.reject(error)
   }
)

const requestGeneric = {
   get: (url, params) => axios.get(url, params),
   post: (url, body) => axios.post(url, body),
   put: (url, body) => axios.put(url, body),
   delete: url => axios.delete(url),
   deleteData: (url, body) => axios.delete(url, body),
   patch: (url, body) => axios.patch(url, body)
}

export default requestGeneric
